import { Link, Navigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { IssueDetail } from '@/features/issues/components/IssueDetail';

export function IssueDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/issues" replace />;

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" asChild>
        <Link to="/issues">← Back to issues</Link>
      </Button>
      <IssueDetail id={id} />
    </div>
  );
}
